import { fetchBusinessInfo, updateBusinessInfo } from "@/api/providerDashboard";
import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

const dayOrder = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const createDefaultReceivingHours = () => ({
  open: "",
  close: "",
  isOpen: true,
});

const normalizeReceivingHours = (value) => {
  const hasWeekdayHours =
    value &&
    typeof value === "object" &&
    dayOrder.some((day) => value[day] && typeof value[day] === "object");
  const legacyStart =
    typeof (value && value.start) === "string" ? value.start : "";
  const legacyEnd = typeof (value && value.end) === "string" ? value.end : "";

  return dayOrder.reduce((hours, day) => {
    const hoursForDay = hasWeekdayHours ? value[day] || {} : {};
    hours[day] = {
      open: hasWeekdayHours
        ? typeof hoursForDay.open === "string"
          ? hoursForDay.open
          : ""
        : legacyStart,
      close: hasWeekdayHours
        ? typeof hoursForDay.close === "string"
          ? hoursForDay.close
          : ""
        : legacyEnd,
      isOpen: hasWeekdayHours ? hoursForDay.isOpen !== false : true,
    };
    return hours;
  }, {});
};

export default {
  data() {
    return {
      loading: true,
      comparisonEstimateEnabled: true,
      comparisonEstimateReceivingHours: dayOrder.reduce((hours, day) => {
        hours[day] = createDefaultReceivingHours();
        return hours;
      }, {}),
      dayOrder,
      dayLabels: {
        mon: "월",
        tue: "화",
        wed: "수",
        thu: "목",
        fri: "금",
        sat: "토",
        sun: "일",
      },
      saveTimeout: null,
    };
  },
  ...createManagementPageLifecycle({
    navbar: "5",
    navbarHook: "mounted",
    loadMethods: ["loadSettings"],
  }),
  methods: {
    async loadSettings() {
      try {
        const res = await fetchBusinessInfo();
        if (res.data.status === 200 && res.data.data) {
          const provider = res.data.data;
          this.comparisonEstimateEnabled =
            provider.comparisonEstimateEnabled !== false;
          this.comparisonEstimateReceivingHours = normalizeReceivingHours(
            provider.comparisonEstimateReceivingHours
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    hasIncompleteReceivingHours() {
      return dayOrder.some((day) => {
        const entry =
          (this.comparisonEstimateReceivingHours &&
            this.comparisonEstimateReceivingHours[day]) ||
          {};
        if (entry.isOpen === false) {
          return false;
        }
        const open = typeof entry.open === "string" ? entry.open.trim() : "";
        const close = typeof entry.close === "string" ? entry.close.trim() : "";
        return Boolean(open) !== Boolean(close);
      });
    },
    save() {
      clearTimeout(this.saveTimeout);
      this.saveTimeout = null;
      if (this.hasIncompleteReceivingHours()) {
        return;
      }
      this.saveTimeout = setTimeout(() => this.doSave(), 500);
    },
    async doSave() {
      if (this.hasIncompleteReceivingHours()) {
        return;
      }
      try {
        const normalizedHours = normalizeReceivingHours(
          this.comparisonEstimateReceivingHours
        );
        dayOrder.forEach((day) => {
          if (!normalizedHours[day].isOpen) {
            normalizedHours[day].open = "";
            normalizedHours[day].close = "";
          }
        });
        this.comparisonEstimateReceivingHours = normalizedHours;
        const res = await updateBusinessInfo({
          comparisonEstimateEnabled: this.comparisonEstimateEnabled,
          comparisonEstimateReceivingHours:
            this.comparisonEstimateReceivingHours,
        });
        if (res.data.status === 200) {
          this.$message.success("저장되었습니다.");
        } else {
          this.$alert(res.data.message || "저장 실패");
        }
      } catch (err) {
        this.$alert("저장 실패");
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.saveTimeout);
  },
};
